export enum CurrencyType
{
    Any = -200,
    ETH = 0,
    RipeToken = 1,
    USDT = 2,
    USDC = 3,
    USDT_L1 = 4,
    USDC_L1 = 5
}